const state = {
  title: '',
  items: [],
  past: {
    title: '',
    items: [],
    total: 0
  },
  upcoming: {
    title: '',
    items: [],
    total: 0
  },
  calendar: {
    title: '',
    items: [],
    total: 0,
    range: {
      min: 0,
      max: 0
    }
  },
  detail: {
    total: 0,
    items: []
  },
  months: {},
  colors: {}
}

const getters = {
  getTitle: state => state.title,
  getItems: state => state.items,

  getPast: state => state.past,
  getPastTitle: state => state.past.title,
  getPastTotal: state => state.past.total,
  getPastItems: state => state.past.items,
  getPastOffset: state => state.past.items.length,

  getUpcoming: state => state.upcoming,
  getUpcomingTitle: state => state.upcoming.title,
  getUpcomingTotal: state => state.upcoming.total,
  getUpcomingItems: state => state.upcoming.items,
  getUpcomingOffset: state => state.upcoming.items.length,

  getCalendarTitle: state => state.calendar.title,
  getCalendarItems: state => state.calendar.items,

  getCalendarRange: state => state.calendar.range,
  getDetail: state => state.detail.items.length ? state.detail.items[0] : {},
  getMonths: state => state.months,
  getColors: state => state.colors
}

const mutations = {
  UPDATE_TITLE: (state, string) => {
    state.title = string
  },
  UPDATE_ITEMS: (state, items) => {
    state.items = [ ...items ]
  },
  UPDATE_PAST_TITLE: (state, string) => {
    state.past.title = string
  },
  UPDATE_PAST_TOTAL: (state, number) => {
    state.past.total = number || 0
  },
  UPDATE_PAST_ITEMS: (state, array) => {
    state.past.items = [ ...array ]
  },
  ADD_PAST_ITEMS: (state, array) => {
    state.past.items = [ ...state.past.items, ...array ]
  },
  UPDATE_UPCOMING_TITLE: (state, string) => {
    state.upcoming.title = string
  },
  UPDATE_UPCOMING_TOTAL: (state, number) => {
    state.upcoming.total = number || 0
  },
  UPDATE_UPCOMING_ITEMS: (state, array) => {
    state.upcoming.items = [ ...array ]
  },
  ADD_UPCOMING_ITEMS: (state, array) => {
    state.upcoming.items = [ ...state.upcoming.items, ...array ]
  },
  UPDATE_CALENDAR_TITLE: (state, string) => {
    state.calendar.title = string
  },
  UPDATE_CALENDAR_ITEMS: (state, array) => {
    state.calendar.items = [ ...array ]
  },
  UPDATE_CALENDAR_RANGE: (state, object) => {
    state.calendar.range = { ...object }
  },
  UPDATE_DETAIL_ITEMS: (state, array) => {
    state.detail.items = [ ...array ]
  },
  UPDATE_COLORS: (state, object) => {
    state.colors = { ...object }
  },
  UPDATE_MONTHS: (state, object) => {
    state.months = { ...object }
  }
}

const actions = {
  updateTitle: ({ commit }, title) => {
    commit('UPDATE_TITLE', title)
  },
  updateItems: ({ commit }, items) => {
    commit('UPDATE_ITEMS', items)
  },
  updatePastTitle: ({ commit }, title) => {
    commit('UPDATE_PAST_TITLE', title)
  },
  updatePastTotal: ({ commit }, total) => {
    commit('UPDATE_PAST_TOTAL', total)
  },
  updatePastItems: ({ commit }, items) => {
    commit('UPDATE_PAST_ITEMS', items)
  },
  addPastItems: ({ commit, dispatch }, events) => {
    commit('ADD_PAST_ITEMS', events.items)
    dispatch('updatePastTotal', events.total)
  },
  updateUpcomingTitle: ({ commit }, title) => {
    commit('UPDATE_UPCOMING_TITLE', title)
  },
  updateUpcomingTotal: ({ commit }, total) => {
    commit('UPDATE_UPCOMING_TOTAL', total)
  },
  updateUpcomingItems: ({ commit }, items) => {
    commit('UPDATE_UPCOMING_ITEMS', items)
  },
  addUpcomingItems: ({ commit, dispatch }, events) => {
    commit('ADD_UPCOMING_ITEMS', events.items)
    dispatch('updateUpcomingTotal', events.total)
  },
  updateCalendarTitle: ({ commit }, title) => {
    commit('UPDATE_CALENDAR_TITLE', title)
  },
  updateCalendarItems: ({ commit }, items) => {
    commit('UPDATE_CALENDAR_ITEMS', items)
  },
  updateCalendarRange: ({ commit }, range) => {
    commit('UPDATE_CALENDAR_RANGE', range)
  },
  updateDetailItems: ({ commit }, items) => {
    commit('UPDATE_DETAIL_ITEMS', items)
  },
  updateColors: ({ commit }, colors) => {
    commit('UPDATE_COLORS', colors)
  },
  updateMonths: ({ commit }, months) => {
    commit('UPDATE_MONTHS', months)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
